/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The available sort by criteria to choose from.
 */
export type VerificationCodeBatchSortByParam =
  (typeof VerificationCodeBatchSortByParam)[keyof typeof VerificationCodeBatchSortByParam];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerificationCodeBatchSortByParam = {
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
  CREATED_AT_ASC: "CREATED_AT_ASC",
  CREATED_AT_DESC: "CREATED_AT_DESC",
  VALID_UNTIL_ASC: "VALID_UNTIL_ASC",
  VALID_UNTIL_DESC: "VALID_UNTIL_DESC",
} as const;
